import { AaHighlight } from "@/app-autocomplete/components/AaHighlight.tsx";
import { AaSnippet } from "@/app-autocomplete/components/AaSnippet.tsx";
import { Panel } from "@/app-autocomplete/components/Panel.tsx";
import { useCollection } from "@/app-autocomplete/hooks/useCollection.ts";
import { useAutocomplete } from "@/app-autocomplete/providers/AutocompleteProvider.tsx";
import { useTranslations } from "@/hooks/useTranslations.ts";


export function Content() {
	const { autocomplete } = useAutocomplete();
	const tc = useTranslations();
	const { items, source } = useCollection("contentPlugin");
	if (items.length === 0) return <></>;

	return (
		<Panel title={tc.content}>
			<ol
				className="aa-Source aa-content"
				{...autocomplete.getListProps({
					source: source,
				})}
			>
				{items.map((item) => (
					<li
						data-item-id={item.itemId}
						key={item.objectID}
						{...autocomplete.getItemProps({
							item: item,
							source: source,
						})}
						className="aa-content__item"
					>
						<a href={item.url} className="aa-content__link">
							{
								<div className={"aa-content__img"}>
									{item?.image && item?.image?.imageUrl && (
										<img
											src={item.image.imageUrl.replace("www.", "")}
											alt={item.image.altText || ""}
											width={55}
											height={55}
											aria-hidden={true}
										/>
									)}
								</div>
							}
							<div className={"aa-content__content"}>
								{item?.title && typeof item?.title === "string" && (
									<div className={"aa-content__title"}>
										{item?.isBastelwelt && (
											<>
												<span className="aa-content__badge">Basteltipp</span>
												<br />
											</>
										)}

										{item?.breadcrumb && typeof item?.breadcrumb === "string" && item?.breadcrumb.length > 0 && (
											<>
												<AaHighlight hit={item} attribute="breadcrumb" />
												{" "}/{" "}
											</>
										)}

										<AaHighlight hit={item} attribute="title" />
									</div>
								)}

								{item?.content && typeof item?.content === "string" && (
									<p className={"aa-content__text"}>
										<AaSnippet hit={item} attribute="content" />
									</p>
								)}
							</div>
							<i className="icon icon-arrow-right" aria-hidden={true} />
						</a>
					</li>
				))}
			</ol>
		</Panel>
	);
}
